import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getRoomOfferAnalyticsContexts} from 'middleware/analytics/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {
  getHotelApiRoomsParameters,
  getHotelResult
} from 'modules/searchApi/selectors'

import {useNetworkStatus} from '@vio/core/src/_web/utils/network/hooks/useNetworkStatus'
import {trackProviderRedirect} from '@vio/core/src/analytics/modules/actions'
import {BOFH_PROXY_PROVIDER_CODE} from '@vio/core/src/offer/business/isBofhOffer'
import {Offer} from '@vio/core/src/offer/types/offer'
import {Room} from '@vio/core/src/room/types/room'
import {DealFreezeButton} from '@vio/shared/src/dealFreeze/components/DealFreezeButton'
import {ComponentSource} from '@vio/shared/src/dealFreeze/types'

type Props = {
  hotelId: string
  room?: Room
  offer: Offer
}

export const RoomOfferDealFreezeCTA = ({hotelId, room, offer}: Props) => {
  const dispatch = useDispatch()
  const isOnline = useNetworkStatus()
  const {data: hotel} = useSelector(state => getHotelResult(state, hotelId))
  const {checkIn, checkOut, rooms} = useSelector(state =>
    getHotelApiRoomsParameters(state, hotelId)
  )
  const analyticsContext = useSelector(state =>
    getRoomOfferAnalyticsContexts(state, offer.id)
  )

  return (
    <DealFreezeButton
      fullWidth
      disabled={!isOnline}
      offerId={offer.id}
      hotel={hotel}
      searchDetail={{checkIn, checkOut, roomsSplit: rooms}}
      analyticsContext={analyticsContext}
      leadContextRequiredData={{
        trackProviderRedirect,
        providerRateType: offer.metadata.providerRateType,
        intermediaryProvider: BOFH_PROXY_PROVIDER_CODE
      }}
      room={room}
      component={ComponentSource.HotelViewRoomsSection}
      onClick={() => dispatch(hideOverlay())}
    />
  )
}
